import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import "../Styles/Shop.css";

const shopProducts = [
  {
    id: 1,
    name: "Mobile Top-Up",
    description: "Instant top-up for GTT, Digicel or Enet",
    type: "topup",
    image: "/products/topup.jpg",
    note: "Topup any carrier, GTT, Digicel or Enet!",
    modalNote: "Enter a valid mobile number and choose your carrier."
  },
  {
    id: 2,
    name: "Insurance Renewal",
    description: "Renew your insurance policy hassle-free",
    type: "insurance",
    image: "/products/insurance.jpg",
    note: "Renewing your insurance has never been this easy!",
    modalNote: "Enter your renewal number which is found on the top right hand of your certificate."
  },
  {
    id: 3,
    name: "MMG Transaction",
    description: "Send MMG to any number securely",
    type: "mmg",
    image: "/products/mmg.jpg",
    note: "Services available for both subscribers and agents",
    modalNote: "Use the subscriber or agent's name and number carefully."
  },
  {
    id: 4,
    name: "MMO Send Money",
    description: "Send money to a non mmg account holder",
    type: "mmg",
    image: "/products/mmg.jpg",
    note: "Use this service if you are sending money to a person who does not have an mmg account",
    modalNote: "Please select MMO, for type, Ensure you insert the receiver's CORRECT name ."
  },
];



const Shop = () => {
  const [cart, setCart] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [formData, setFormData] = useState({
    type: "",
    name: "",
    number: "",
    amount: "",
  });
  const [showPreview, setShowPreview] = useState(false);
  const [checkoutStep, setCheckoutStep] = useState(1); // Step 1 = confirm, Step 2 = payment method
  const [paymentMethod, setPaymentMethod] = useState(""); // stripe, mmg, paypal
  const [showStripeSummary, setShowStripeSummary] = useState(false);

  const calculatePayPalAmounts = () => {
    const baseGYD = getTotal();
    let feeUSD = 1.5;
  
    if (baseGYD >= 100000) {
      feeUSD = baseGYD > 200000 ? 30 : 15;
    } else if (baseGYD >= 50000) {
      feeUSD = 10;
    } else if (baseGYD >= 10000) {
      feeUSD = 3;
    }
  
    const convertedUSD = (baseGYD / 218).toFixed(2);
    const totalWithFee = (parseFloat(convertedUSD) + feeUSD).toFixed(2);
  
    return {
      baseUSD: parseFloat(convertedUSD),
      feeUSD,
      totalUSD: parseFloat(totalWithFee)
    };
  };
  
  const openModal = (product) => {
    setSelectedProduct(product);
    setFormData({ type: "", name: "", number: "", amount: "" });
  };

  const addToCart = () => {
    const entry = {
      name: selectedProduct.name,
      details: { ...formData },
      price: Number(formData.amount.toString().replace(/[^0-9.]/g, "")) || 0,

    };
    setCart([...cart, entry]);
    setSelectedProduct(null);
  };

  const removeFromCart = (index) => {
    const updated = [...cart];
    updated.splice(index, 1);
    setCart(updated);
  };

  const getTotal = () =>
    cart.reduce((sum, item) => sum + (item.price || 0), 0);

  return (
    <div className="shop-container">
      <h2>🛒 Online Shop</h2>

      <div className="shop-content">
        <div className="product-grid">
          {shopProducts.map((product) => (
            <div className="product-card" key={product.id}>
              <img src={product.image} alt={product.name} />
              <h3>{product.name}</h3>
              <p>{product.description}</p>
              <p><i>{product.note}</i></p>
              <button onClick={() => openModal(product)}>Select</button>
            </div>
          ))}
        </div>

        <div className="cart-sidebar">
          <h3>🛒 Your Cart</h3>
          {cart.length === 0 ? (
            <>
              <p>No items added yet.</p>
              <hr />
              <p><strong>Total:</strong> $0</p>
            </>
          ) : (
            <>
              <ul>
                {cart.map((item, index) => (
                  <li key={index}>
                    {item.name} - ${item.price.toLocaleString()}
                    <button onClick={() => removeFromCart(index)}>❌</button>
                  </li>
                ))}
              </ul>
              <hr />
              <p><strong>Total:</strong> ${getTotal().toLocaleString()}</p>
              <button className="checkout-btn" onClick={() => setShowPreview(true)}>
                Proceed to Checkout
              </button>
            </>
          )}
        </div>
      </div>

      {selectedProduct && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>{selectedProduct.name}</h3>

            {selectedProduct.type === "topup" && (
              <>
                <label>Type:</label>
                <select
                  value={formData.type}
                  onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                >
                  <option value="">Select</option>
                  <option value="GTT">GTT</option>
                  <option value="Digicel">Digicel</option>
                  <option value="Enet">Enet</option>
                </select>

                <label>Number:</label>
                <input
                  type="text"
                  value={formData.number}
                  onChange={(e) => setFormData({ ...formData, number: e.target.value })}
                />

                <label>Amount:</label>
                <input
                  type="number"
                  value={formData.amount}
                  onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                />
              </>
            )}

            {selectedProduct.type === "insurance" && (
              <>
                <label>Renewal Number:</label>
                <input
                  type="text"
                  value={formData.number}
                  onChange={(e) => setFormData({ ...formData, number: e.target.value })}
                />
                <label>Amount:</label>
                <input
                  type="number"
                  value={formData.amount}
                  onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                />
              </>
            )}

{/* ✅ Product 4: Custom Modal for MMO Send Money */}
{selectedProduct.name === "MMO Send Money" && (
  <>
    <label>Type:</label>
    <select
      value={formData.type}
      onChange={(e) => setFormData({ ...formData, type: e.target.value })}
    >
      <option value="MMO">MMO</option>
    </select>

    <label>Receiver:</label>
    <input
      type="text"
      value={formData.receiver || ""}
      onChange={(e) =>
        setFormData({ ...formData, receiver: e.target.value })
      }
    />

    <label>Name:</label>
    <input
      type="text"
      value={formData.name}
      onChange={(e) =>
        setFormData({ ...formData, name: e.target.value })
      }
    />

    <label>Number:</label>
    <input
      type="text"
      value={formData.number}
      onChange={(e) =>
        setFormData({ ...formData, number: e.target.value })
      }
    />

    <label>Amount:</label>
    <input
      type="number"
      value={formData.amount}
      onChange={(e) =>
        setFormData({ ...formData, amount: e.target.value })
      }
    />
  </>
)}

{/* ✅ Product 3: Regular MMG Transactions */}
{selectedProduct.type === "mmg" && selectedProduct.name !== "MMO Send Money" && (
  <>
    <label>Type:</label>
    <select
      value={formData.type}
      onChange={(e) => setFormData({ ...formData, type: e.target.value })}
    >
      <option value="">Select</option>
      <option value="Subscriber Deposit">Subscriber Deposit</option>
      <option value="Agent Transfer">Agent Transfer</option>
      <option value="MMO">MMO</option>
    </select>

    <label>Name:</label>
    <input
      type="text"
      value={formData.name}
      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
    />

    <label>Number:</label>
    <input
      type="text"
      value={formData.number}
      onChange={(e) => setFormData({ ...formData, number: e.target.value })}
    />

    <label>Amount:</label>
    <input
      type="number"
      value={formData.amount}
      onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
    />
  </>
)}


{selectedProduct.modalNote && (
  <p><strong><i>Note: {selectedProduct.modalNote}</i></strong></p>
)}

            <div className="modal-buttons">
              <button onClick={addToCart}>Add</button>
              <button onClick={() => setSelectedProduct(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

{showPreview && (
  <div className="modal-overlay">
    <div className="modal">
      {checkoutStep === 1 && (
        <>
          <h3>🧾 Confirm Your Order</h3>
          <ul>
            {cart.map((item, index) => (
              <li key={index}>
                {item.name} - ${item.price.toLocaleString()}
              </li>
            ))}
          </ul>
          <p><strong>Total:</strong> ${getTotal().toLocaleString()}</p>

          <div className="modal-buttons">
            <button onClick={() => setCheckoutStep(2)}>Confirm & Pay</button>
            <button onClick={() => {
              setShowPreview(false);
              setCheckoutStep(1);
            }}>Cancel</button>
          </div>
        </>
      )}

{checkoutStep === 2 && (
  <>
    <h3>💳 Choose Payment Method</h3>

    <div className="payment-options">
  <label className="payment-toggle">
    <span>Stripe</span>
    <input
      type="checkbox"
      checked={paymentMethod === "stripe"}
      onChange={() => {
        setPaymentMethod("stripe");
        setShowStripeSummary(true);
      }}
    />
  </label>

  <label className="payment-toggle">
  <span>PayPal</span>
  <input
    type="checkbox"
    checked={paymentMethod === "paypal"}
    onChange={() => {
      setPaymentMethod("paypal");
      setShowStripeSummary(false);
    }}
  />
</label>
{paymentMethod === "paypal" && (
  <div className="paypal-summary-overlay">
    <div className="paypal-summary-modal">
      <h4>🟦 PayPal Payment Summary</h4>
      {(() => {
        const { baseUSD, feeUSD, totalUSD } = calculatePayPalAmounts();
        return (
          <>
            <p><strong>Base Amount:</strong> ${baseUSD.toFixed(2)}</p>
            <p><strong>Service Fee:</strong> ${feeUSD.toFixed(2)}</p>
            <hr />
            <p><strong>Final Total:</strong> ${totalUSD.toFixed(2)}</p>
          </>
        );
      })()}
      <p style={{ marginTop: "1rem", color: "green", fontStyle: "italic" }}>
        You will be redirected to PayPal to complete your payment.
      </p>
    </div>
  </div>
)}



  <label className="payment-toggle">
    <span>MMG</span>
    <input
      type="checkbox"
      checked={paymentMethod === "mmg"}
      onChange={() => {
        setPaymentMethod("mmg");
        setShowStripeSummary(false);
      }}
    />
  </label>
</div>


    <div className="modal-buttons">
      <button
        onClick={() => {
          if (!paymentMethod) return alert("Please select a payment method");

          let finalCart = [...cart];

          if (paymentMethod === "stripe") {
            const baseTotalGYD = getTotal();
          
            // 💵 Determine Stripe Fee in USD based on GYD total
            let stripeFeeUSD = 1.5;
            if (baseTotalGYD >= 100000) {
              stripeFeeUSD = baseTotalGYD > 200000 ? 30 : 15;
            } else if (baseTotalGYD >= 50000) {
              stripeFeeUSD = 10;
            } else if (baseTotalGYD >= 10000) {
              stripeFeeUSD = 3;
            }
          
            // 🔄 Convert all cart prices to USD
            finalCart = cart.map(item => ({
              ...item,
              price: parseFloat((item.price / 218).toFixed(2)), // Convert GYD → USD
            }));
          
            // ➕ Add Stripe Fee as final line item
            finalCart.push({
              name: "Stripe Service Fee",
              details: { tiered: `GYD ${baseTotalGYD.toLocaleString()} → $${stripeFeeUSD.toFixed(2)} USD` },
              price: stripeFeeUSD,
            });
          }
          

          localStorage.setItem("rcs_cart", JSON.stringify(finalCart));

          localStorage.setItem("rcs_cart", JSON.stringify(finalCart));

          if (paymentMethod === "stripe") {
            window.location.href = "/checkout";
          } 
          else if (paymentMethod === "paypal") {
            const { totalUSD } = calculatePayPalAmounts();
            const paypalEmail = "rupeshcoysilram2001@gmail.com"; // your PayPal email
            const itemName = "Order from RCS Online Shop";
          
            const paypalUrl = `https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=${paypalEmail}&currency_code=USD&amount=${totalUSD}&item_name=${encodeURIComponent(itemName)}&return=https://rcsgy.com/checkout-success`;
          
            window.location.href = paypalUrl;
          }
          
           else if (paymentMethod === "mmg") {
            localStorage.setItem("rcs_cart", JSON.stringify(cart));
            window.location.href = "/mmg-checkout";
          }
          
          
          setShowPreview(false);
          setCheckoutStep(1);
          setShowStripeSummary(false);
          
        }}
      >
        Continue
      </button>

      <button
        onClick={() => {
          setCheckoutStep(1);
          setShowStripeSummary(false);
        }}
      >
        ⬅ Back
      </button>
    </div>
  </>
)}

{/* ✅ Separate Stripe Summary Modal */}
{showStripeSummary && (
  <div className="stripe-summary-overlay">
    <div className="stripe-summary-modal">
      <h4>💎 Stripe Payment Summary</h4>
      <p>Base Amount: ${(getTotal() / 218).toFixed(2)}</p>
      <p>
        Service Fee: $
        {
          getTotal() >= 100000
            ? getTotal() > 200000
              ? 30
              : 15
            : getTotal() >= 50000
            ? 10
            : getTotal() >= 10000
            ? 3
            : 1.5
        }
      </p>
      <hr />
      <p>
        <strong>
          Final Total: $
          {(
            getTotal() / 218 +
            (getTotal() >= 100000
              ? getTotal() > 200000
                ? 30
                : 15
              : getTotal() >= 50000
              ? 10
              : getTotal() >= 10000
              ? 3
              : 1.5)
          ).toFixed(2)}
        </strong>
      </p>
    </div>
  </div>
)}


    </div>
  </div>
)}

    </div>
  );
};

export default Shop;
